var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevModeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4409 0.522202C6.29985 0.670546 6.29985 0.911168 6.4409 1.05965L7.62992 2.31138L6.44103 3.56312C6.29998 3.71147 6.29998 3.95209 6.44103 4.10057C6.51143 4.1748 6.60387 4.21193 6.69631 4.21193C6.78876 4.21193 6.8812 4.17481 6.95147 4.10057L8.39591 2.58011C8.53696 2.43176 8.53696 2.19114 8.39591 2.04266L6.95147 0.522202C6.81068 0.373723 6.58171 0.373723 6.4409 0.522202Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09713 0.269534L3.65269 4.0706C3.57876 4.26562 3.66869 4.48688 3.85407 4.5647C3.89802 4.58326 3.94324 4.59201 3.98807 4.59201C4.13116 4.59201 4.2668 4.50173 4.32322 4.35299L5.76765 0.551923C5.84171 0.356897 5.7518 0.13577 5.56653 0.0578179C5.38125 -0.0201345 5.17118 0.0745224 5.09713 0.269534Z",
    fill: "#FCFCFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.46883 0.522067L1.0244 2.04253C0.883469 2.19101 0.883469 2.43163 1.0244 2.58011L2.46883 4.10057C2.53923 4.1748 2.63168 4.21193 2.72412 4.21193C2.81656 4.21193 2.909 4.17481 2.9794 4.10057C3.12046 3.95222 3.12046 3.7116 2.9794 3.56312L1.79051 2.31138L2.9794 1.05951C3.12046 0.911167 3.12046 0.670546 2.9794 0.522067C2.8386 0.373588 2.60963 0.373588 2.46883 0.522067Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevModeIcon);
export default __webpack_public_path__ + "static/media/dev-mode-icon.ca55bb2d3782a0c1ac541e17356fd499.svg";
export { ForwardRef as ReactComponent };